/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsPositive } from '../../factoriesAny.js';
export var isPositiveDependencies = {
  typedDependencies,
  createIsPositive
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsPositive.generated.js
// module id = null
// module chunks = 